var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRolloverServices = function SvgRolloverServices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    fill: "none",
    viewBox: "0 0 128 128"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DAD6CD",
    d: "M105.635 14.676V115.2c0 4.427-3.745 8.02-8.36 8.02h-74.58a8.6 8.6 0 0 1-2.106-.262c-3.6-.898-6.253-4.026-6.253-7.758V14.676c0-4.433 3.745-8.02 8.36-8.02h74.58c4.614 0 8.359 3.587 8.359 8.02"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1BDFF",
    d: "M111.801 101.884H75.264V49.152h36.537c6.114 0 11.079 5.304 11.079 11.844v29.048c0 6.536-4.961 11.844-11.079 11.844z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7886D9",
    d: "M75.148 102.057H39.019c-6.558 0-11.883-5.321-11.883-11.883V61.035c0-6.558 5.321-11.883 11.883-11.883h36.129z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3992",
    d: "M75.264 101.884h36.352V49.152H75.264v52.736z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B216B",
    d: "M38.912 101.884h36.352V49.152H38.912v52.736z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFECB1",
    d: "M75.188 93.178c9.87 0 17.87-8 17.87-17.87s-8-17.87-17.87-17.87-17.87 8-17.87 17.87 8 17.87 17.87 17.87"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD008",
    d: "M75.204 93.17c-9.87.007-17.878-7.977-17.886-17.847s7.976-17.878 17.846-17.886"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA5B",
    d: "M105.659 61.797c12.263 0 22.203-9.707 22.203-21.682s-9.94-21.683-22.203-21.683-22.203 9.708-22.203 21.683 9.94 21.682 22.203 21.682"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD00",
    d: "M105.718 61.792V18.438h-.059c-12.263 0-22.203 9.707-22.203 21.683s9.94 21.682 22.203 21.682h.059z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#4154AE",
    d: "M116.404 33.766h1.784v7h-7.168v-1.731h3.9c-1.601-2.944-5.13-5.344-9.55-5.281-4.935.075-9.438 3.44-10.425 8.772h-1.808c.561-3.878 3.327-8.183 8.421-9.863 5.1-1.685 11.465-.098 14.846 5.321v-4.218"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#4154AE",
    d: "M95.73 43.49h-3.57l.142-.987c.532-3.677 3.215-8.646 9.013-10.568 5.147-1.702 10.667-.236 14.248 3.555v-2.493h3.558v8.732h-8.942v-3.462h3.15c-1.814-2.24-4.769-3.608-7.901-3.55-4.769.07-8.705 3.388-9.568 8.057l-.13.71zm-1.478-1.732h.018c.19-.756.45-1.483.768-2.164a12 12 0 0 0-.786 2.164m23.084-1.754h.012l-.012-5.27zm-5.384 0h4.663l-.922-1.472c-2.299-3.682-5.868-5.298-9.266-5.512 3.953.272 7.541 2.442 9.319 5.714l.692 1.27z"
  })));
};
export { SvgRolloverServices as Icon };
export default __webpack_public_path__ + "static/media/4a6d11e610be60f897c4d7c8a22612f7.svg";